import type { TenantSubscriptionType } from "@/interfaces";

/** Formats an approaching trial/renewal deadline in whole days, then nonzero hours. */
export const getSubscriptionBannerMessage = (subscription: TenantSubscriptionType, now = Date.now()): string | null => {
  const trial = subscription.subscriptionPlan === "trial";
  const deadline = trial ? subscription.trialEndDate : subscription.subscriptionRenewalDate;
  if (!deadline) return null;
  const remaining = new Date(deadline).getTime() - now;
  const day = 86400000;
  if (!Number.isFinite(remaining) || remaining > (trial ? 2 : 15) * day) return null;
  if (remaining <= 0) return trial
    ? "Your trial has ended. Your account is inactive. Contact your administrator."
    : "Your subscription is due for renewal. Contact your administrator to renew.";
  const days = Math.floor(remaining / day);
  const hours = Math.max(1, Math.ceil(remaining / 3600000));
  const duration = days > 0 ? `${days} ${days === 1 ? "day" : "days"}` : `${hours} ${hours === 1 ? "hour" : "hours"}`;
  return trial
    ? `Your trial ends in ${duration}. Contact your administrator to continue your subscription.`
    : `Your subscription is due for renewal in ${duration}. Contact your administrator to renew.`;
};
